export default [
  {
    path: "/set/myInfoSet/myInfoSet",
    name: "my-info-set",
    component: () =>
      import("@/views/set/myInfoSet/myInfoSet.vue"),
  },
];
